export default __webpack_public_path__ + "static/media/img-7.4abf232d.jpg";